<template>
  <div
    class="node-container"
    :class="{
      'node-selected': isActive,
      'node-object': isObject,
    }"
  >
    <!-- IF ARRAY JUST PROCESS DATA AGAIN -->
    <div v-if="isArray" class="node-children node-list">
      <object-header
        :nameClick="() => handleNameClick(makePath())"
        :toggle="() => handleToggleCollapsed()"
        :collapsed='collapsed'
        :path="makePath()"
        descr="Nested list: "
        useClass="p-5 row between array-header c-v node-list"
      >
        <node-menu v-if="isActive()" v-bind="$props" :extended="true" />
      </object-header>
      <div class="node-list" :class="{'node-collapsed': collapsed.includes(nodeId)}">
        <div
          v-for="(child, index) in rootObject"
          :key="`${index}-${index}`"
          class='array-node-item'
        >
          <div
            class="drop-section"
            v-if="dropMode && index === 0"
            @click="() => handleDropSectionClick(makePath(0))"
          >
            {{ makePath(0) }} (in array)
          </div>
          <object-header
            :nameClick="() => handleNameClick(makePath(index))"
            :toggle="() => handleToggleCollapsed(index)"
            :collapsed='collapsed'
            :path="makePath(index)"
            v-if="isChildObject(index)"
          >
            <node-menu
                v-if="isActive(index)"
                v-bind="$props"
                :extended="true"
                :nodeId="makePath(index)"
                :rootObject="child"
              />
          </object-header>
          <render-object-structure
            v-bind="$props"
            :rootObject="child"
            :nodeId="makePath(index)"
          />
          <div
            v-if="dropMode"
            class="drop-section"
            @click="() => handleDropSectionClick(makePath(index + 1))"
          >
            {{ makePath(index + 1) }} (in array)
          </div>
        </div>
      </div>
    </div>
    <div
      class="p-5 row between object-header c-v"
      v-else-if="nodeId === 'root' || objWithList"
      @click.stop="() => handleNameClick(`${nodeId}`)"
    >
      <div>
        <span class="node-path"> {{ nodeId }} </span>
      </div>
      <node-menu v-if="isActive()" v-bind="$props" :extended="true" />
      <div v-else class="p-15" />
    </div>
    <div
      v-if="dropMode && objWithList && nodeId !== 'root'"
      class="drop-section object-drop"
      @click="() => handleDropSectionClick(makePath('object'))"
    >
      {{ makePath() }} (in object)
    </div>
    <div
        v-if="dropMode && nodeId === 'root'"
        class="drop-section object-drop"
        @click="() => handleDropSectionClick(makePath())"
    >{{ makePath() }} (in root)
    </div>
    <!-- TEXT NODE DATA -->
    <div
      v-if="typeof rootObject === 'string'"
      class="text-node node-children row between c-v"
      @click.stop="() => handleNameClick(`${nodeId}`)"
    >
      <div v-if="isActive()" class="w-90">
        <textarea
          @click.stop
          class="form-field"
          :value="rootObject"
          @input="(e) =>
            handleFieldChange(0, e.target.value, makePath())"
        />
      </div>
      <span v-else>{{ rootObject }}</span>
      <div class="row c-v">
        <span class="node-path right" v-if="!isActive()">
          {{ nodeId }}
        </span>
        <node-menu v-else v-bind="$props" />
      </div>
    </div>
    <!-- OBJECT / KEY PAIR TYPE -->
    <div
      v-else-if="!isArray"
      v-for="(key, i) in Object.keys(rootObject).sort()"
      :key="`${key}-${i}`"
      :class="{
        'node-collapsed': !objParent && collapsed.includes(makePath()),
      }"
    >
      <div>
        <div
          class="node-fields-containers node-children"
          :class="{ 'child-header': isChildArray(key) }"
          @click.stop="() => handleNameClick(`${nodeId} > ${key}`)"
        >
          <span
            class="collapse-toggle"
            v-if="isChildArray(key)"
            @click.stop="() => handleToggleCollapsed(key)"
            >{{ collapsed.includes(makePath(key)) ? "+" : "-" }}</span
          >
          <div class="node-key-container">
            <div class="node-key-name row" :class="{ 'w-100': isActive(key) }">
              <!-- KEY -->
              <span class="w-30" v-if="key && isActive(key)">
                <textarea
                  @click.stop
                  class="form-field"
                  :value="editingKey !== null ? editingKey : key"
                  @input="
                    (e) =>
                      handleFieldChange('key', e.target.value, makePath(key))
                  "
                />
              </span>
              <span v-if="key && !isActive(key)">
                <span class="node-name">
                  {{ key }}
                  <span
                    class="node-list-arrow"
                    v-if="
                      isChildArray(key) && !collapsed.includes(makePath(key))
                    "
                  />
                </span>
                <span class="ml-10 node-note" v-if="isChildArray(key)">
                  [Child list]
                </span>
                <span
                  class="ml-10 node-note"
                  v-if="
                    objWithList &&
                    !isChildArray(key) &&
                    typeof rootObject[key] !== 'string'
                  "
                >
                  {{ "[Object container]" }}
                </span>
              </span>
              <!-- KEY VALUE IF NOT ARRAY -->
              <span
                class="ml-15"
                :class="`${isActive(key) ? 'w-65' : ''}`"
                v-if="!isChildArray(key) && typeof rootObject[key] === 'string'"
              >
                <textarea
                  @click.stop
                  class="form-field"
                  :value="rootObject[key]"
                  v-if="isActive(key)"
                  @input="
                    (e) =>
                      handleFieldChange(
                        rootObject[key],
                        e.target.value,
                        makePath(key)
                      )
                  "
                />
                <span v-else>{{ rootObject[key] }}</span>
              </span>
            </div>
            <div class="row between c-v">
              <div class="node-path right" v-if="!isActive(key)">
                {{ `${nodeId} > ${key}` }}
              </div>
              <node-menu
                v-bind="$props"
                v-if="isActive(key)"
                :extended="isChildArray(key)"
                :nodeId="makePath(key)"
                :rootObject="{ [key]: rootObject[key] }"
                :objParent="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="isChildObject(key)"
        class="node-children node-list"
        :class="{ 'node-collapsed': collapsed.includes(makePath(key)) }"
      >
        <div
          class="drop-section"
          v-if="dropMode && makePath(key) !== 'root'"
          @click="() => handleDropSectionClick(makePath(`${key} > object`))"
        >
          {{ makePath(key) }} (in object)
        </div>
        <div
          v-for="(childKey, index) in Object.keys(rootObject[key])"
          :key="`${key}-${index}-${i}-${childKey}`"
        >
          <render-object-structure
            v-bind="$props"
            :rootObject="{ [childKey]: rootObject[key][childKey] }"
            :nodeId="makePath(key)"
            :objParent="true"
          />
        </div>
      </div>
      <div
        v-if="isChildArray(key)"
        class="node-children node-list"
        :class="{ 'node-collapsed': collapsed.includes(makePath(key)) }"
      >
        <div
          v-for="(child, index) in rootObject[key]"
          :key="`${key}-${index}-${i}`"
        >
          <div
            class="drop-section"
            v-if="dropMode && index === 0"
            @click="() => handleDropSectionClick(makePath(`${key} > ${0}`))"
          >
            {{ makePath(`${key} > ${0}`) }} (in array)
          </div>
          <render-object-structure
            v-bind="$props"
            :rootObject="child"
            :nodeId="makePath(`${key} > ${index}`)"
            :objParent="false"
          />
          <div
            class="drop-section"
            v-if="dropMode"
            @click="
              () => handleDropSectionClick(makePath(`${key} > ${index + 1}`))
            "
          >
            {{ makePath(`${key} > ${index + 1}`) }} (in array)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RenderObjectStructure from "./RenderObjectStructure.vue";
import NodeMenu from "./fragments/NodeMenu.vue";
import ObjectHeader from './fragments/ObjectHeader.vue';
export default {
  name: "RenderObjectStructure",
  props: [
    "rootObject",
    "activeNode",
    "handleNodeClick",
    "nodeId",
    "handleDropSectionClick",
    "menuItemClick",
    "updateNodeParam",
    "handleAddChild",
    "collapsed",
    "toggleCollapsed",
    "dropMode",
    "handleFieldChange",
    "editingKey",
    "objParent",
  ],
  components: { RenderObjectStructure, NodeMenu, ObjectHeader },
  data: () => ({}),
  methods: {
    handleNameClick(selectId) {
      this.handleNodeClick(selectId, this.rootObject);
    },
    makePath(key = null) {
      const id = key || key === 0 ? `${this.nodeId} > ${key}` : null;
      return id || this.nodeId;
    },
    handleToggleCollapsed(key) {
      this.toggleCollapsed(this.makePath(key));
    },
    isActive(key = null) {
      return this.activeNode === this.makePath(key);
    },
    isChildArray(key) {
      return Array.isArray(this.rootObject[key]);
    },
    isChildObject(key) {
      return (
        !this.isChildArray(key) && typeof this.rootObject[key] === "object"
      );
    },
  },
  computed: {
    isArray() {
      return Array.isArray(this.rootObject);
    },
    isObject() {
      return typeof this.rootObject === "object";
    },
    isString() {
      return typeof this.rootObject === "string";
    },
    objWithList() {
      const val =
        this.isObject &&
        (Array.isArray(Object.values(this.rootObject)[0]) ||
          typeof Object.values(this.rootObject)[0] === "object");
      return val;
    },
  },
};
</script>

<style lang='scss'>
@import "../../styles/colors";
.node-object {
  $objectColor: rgb(228, 228, 228);
  border-right: 3px solid $objectColor;
  border-top: 3px solid $objectColor;
  background-color: #fff;
  border-radius: 4px;
  border-left: 5px solid $objectColor;
  margin-top: 6px;
  border-bottom: 4px solid $objectColor;
  margin-bottom: 8px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  .node-path {
    padding: 4px 8px;
    color: rgb(196, 196, 196);
  }
  .array-header {
    color: rgb(3, 3, 3);
    padding-top: 6px;
    padding-bottom: 2px;
    border-radius: 4px;
    .node-path {
      color: rgb(172, 172, 172);
    }
  }
  .object-header {
    background-color: $objectColor;
    .node-path {
      color: rgb(63, 63, 63);
    }
  }
  @media screen and (max-width: 600px) {
    .node-path {
      display: none;
    }
  }
}
.node-list {
  padding-bottom: 5px;
  background-color: rgb(243, 237, 238);
  & > div {
    margin-bottom: 3px;
  }
}

.node-container {
  .drop-section {
    background-color: $fieldBg;
    border: 2px dotted $fieldShadow;
    border-radius: 3px;
    transition: all 0.3s;
    text-align: center;
    padding: 7px 0;
    width: 96%;
    font-size: 0.85rem;
    margin: 6px auto 1px auto;
    color: rgb(108, 180, 202);
    &.object-drop {
      margin-bottom: 2px;
      margin-top: 2px;
      width: 98%;
    }
    &:hover {
      background-color: $lightBlue;
      padding: 10px 0;
      color: #fff;
    }
  }
  .collapse-toggle {
    padding: 0 5px;
    font-size: 1.2rem;
    font-weight: bold;
    text-align: center;
    margin-right: 6px;
    margin-left: 3px;
    cursor: pointer;
    border-radius: 4px;
    &:hover {
      background: rgb(43, 43, 43);
      color: #fff;
    }
  }
  .node-name {
    background-color: rgb(153, 153, 153);
    border-radius: 5px;
    color: #fff;
    padding: 5px 5px 3px 5px;
    position: relative;
  }
  .node-children {
    padding: 10px;
    @media screen and (max-width: 600px) {
      padding: 5px 3px;
    }
    margin: 2px 0;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    &.node-list {
      margin-top: 0;
      border-left: 14px solid transparent;
      @media screen and (max-width: 600px) {
        border-left: 2px solid transparent;
      }
    }
    .node-key-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .node-key-name {
        display: flex;
        align-items: center;
        .node-list-arrow {
          border-style: solid;
          border-width: 13px 13px 13px 13px;
          border-color: transparent transparent rgb(153, 153, 153) transparent;
          position: absolute;
          bottom: -28px;
          left: calc(50% - 13px);
        }
        .node-note {
          font-size: 0.8rem;
          color: #999999;
        }
      }
      @media screen and (max-width: 600px) {
        flex-wrap: wrap;
        flex-direction: colomn;
        align-items: center;
        justify-content: center;
        text-align: center;
        & > div {
          width: 100%;
          padding-top: 5px;
          text-align: center;
          span {
            width: 50%;
          }
          .node-list-arrow {
            display: none;
          }
        }
      }
    }
    transition: background-color 0.1s;
    &:hover {
      background-color: rgb(207, 232, 240);
      cursor: pointer;
    }
  }
  .node-fields-containers {
    display: flex;
    align-items: center;
    background: #fff;
  }
  .node-collapsed {
    overflow: hidden;
    border: 1px $maroon;
    height: 0;
    padding: 0;
  }
  .text-node {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
    margin-top: 5px;
  }
}
</style>